import { motion } from "framer-motion";

export default function ProjectCard({ project, onOpen, index }) {
  return (
    <motion.button
      type="button"
      data-testid={`project-card-${project.id}`}
      onClick={() => onOpen(project)}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.55, delay: (index % 4) * 0.08, ease: "easeOut" }}
      whileHover={{ y: -6 }}
      className="group relative text-left border border-[#01FFFF]/15 bg-[#0A0A12]/70 backdrop-blur-xl overflow-hidden p-6 md:p-7"
    >
      <span className="absolute left-2 top-2 h-4 w-4 border-l-2 border-t-2 border-[#01FFFF]" />
      <span className="absolute right-2 top-2 h-4 w-4 border-r-2 border-t-2 border-[#01FFFF]" />
      <span className="absolute left-2 bottom-2 h-4 w-4 border-l-2 border-b-2 border-[#01FFFF]" />
      <span className="absolute right-2 bottom-2 h-4 w-4 border-r-2 border-b-2 border-[#01FFFF]" />

      <span className="font-heading text-4xl text-[#01FFFF]/15 leading-none">{project.index}</span>

      <span className="mt-4 block font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF007F]">
        {project.tag}
      </span>
      <h3 className="mt-2 font-heading text-lg md:text-xl uppercase tracking-tight text-[#E0E6ED]">
        {project.title}
      </h3>
      <p className="mt-2 font-mono text-xs leading-relaxed text-[#8A9AAB] line-clamp-3">
        {project.description}
      </p>
      <span className="mt-4 inline-block font-mono text-[10px] uppercase tracking-widest text-[#01FFFF] opacity-0 transition-opacity duration-200 group-hover:opacity-100">
        View details →
      </span>
    </motion.button>
  );
}
